import React from 'react'
import { UploadElement } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { AiDataExtractionUploadError } from './AiDataExtractionUploadError'
import { AiEmptyUploadImageSection } from './AiEmptyUploadImageSection'

export type AiUploadedImage = {
  id: string
  name: string
  file: File
  previewUrl: string
}

export const getImageIdsInOrder = (items: Array<{ id: string }>) => items.map((item) => item.id)
export const createImageReorderHandler =
  (onReorder: (imageIdsInOrder: string[]) => void) => (items: Array<{ id: string }>) =>
    onReorder(getImageIdsInOrder(items))

interface AiUploadImageSectionProps {
  errorText?: string
  images: AiUploadedImage[]
  onFileSelect: (files: FileList | null) => void
  onRemove: (imageId: string) => void
  onReorder: (imageIdsInOrder: string[]) => void
}

export const AiUploadImageSection = ({
  errorText,
  images,
  onFileSelect,
  onRemove,
  onReorder,
}: AiUploadImageSectionProps) => {
  const { t } = useTranslation()
  const uploadError = errorText ? <AiDataExtractionUploadError message={errorText} /> : null

  if (images.length === 0) {
    return <AiEmptyUploadImageSection errorText={errorText} onFileSelect={onFileSelect} />
  }

  return (
    <section className='margin-bottom-l'>
      <h3 className='font-body-medium-bold margin-bottom-s'>{t('wizard.uploadAiBanner.modal.photos.sectionTitle')}</h3>
      <UploadElement.Root accept='image/jpeg,image/png' onFileSelect={onFileSelect} status='uploaded' multiple>
        <UploadElement.ImageList
          items={images.map((image) => ({
            alt: image.name,
            id: image.id,
            src: image.previewUrl,
          }))}
          onRemove={onRemove}
          onReorder={createImageReorderHandler(onReorder)}
          thumbnailSize={80}
          data-testid='ai-upload-photos-list'
        >
          <UploadElement.AddButton size={80} />
        </UploadElement.ImageList>
      </UploadElement.Root>
      {uploadError ? <div className='margin-top-s'>{uploadError}</div> : null}
    </section>
  )
}
